  
<div _ngcontent-ng-c1591630683="" class="site-header app-header">
<div _ngcontent-ng-c1591630683="" class="before-login-items">
<div _ngcontent-ng-c1591630683="" class="site-logo-con" style="display: flex; align-items: center">
<img _ngcontent-ng-c1591630683="" alt="" class="site-logo ng-star-inserted" routerlink="/" src="https://royall444.com/api/users/images/theme-1742469725615-royal444.png" tabindex="0"/><!-- --><!-- -->
<div _ngcontent-ng-c1591630683="" class="searchIconDiv me-2 ng-input 456456">
<input _ngcontent-ng-c1591630683="" aria-label="Search" class="form-control searchbar ng-untouched ng-pristine ng-valid" id="myInput" placeholder="" type="text"/><span _ngcontent-ng-c1591630683="" aria-hidden="true" class="searchIconCross" id="myClose">×</span><!-- -->
</div>
<!-- -->
<div _ngcontent-ng-c1591630683="" class="searchBox">
<!-- -->
</div>
</div>
<div _ngcontent-ng-c1591630683="" class="login-signup-uname-pass">
<div _ngcontent-ng-c1591630683="" class="header-uname-pass">
<div _ngcontent-ng-c1591630683="" class="d-flex align-items-center phoneNumberDiv me-2">
<input _ngcontent-ng-c1591630683="" autocomplete="off" autofocus="" class="phoneNumberInput ng-untouched ng-pristine ng-valid" id="userName" maxlength="13" name="userName" placeholder="Username" style="padding: 0; border-radius: 3px; width: 100%" tabindex="1" type="text"/>
</div>
<input _ngcontent-ng-c1591630683="" class="password form-control me-2 username userPassword ng-untouched ng-pristine ng-valid" name="passwordformbl" placeholder="Password" type="password"/>
</div>
<div _ngcontent-ng-c1591630683="" class="login-signup">
<button _ngcontent-ng-c1591630683="" class="btn login me-1" data-bs-target="#ageconfirmationModal" data-bs-toggle="modal">
<b _ngcontent-ng-c1591630683="" style="width: 33px; height: 18px">Login</b><i _ngcontent-ng-c1591630683="" class="fa fa-sign-in ms-1"></i>
</button>
</div>
<span _ngcontent-ng-c1591630683="" class="err-invalid"></span><!-- -->
</div>
</div>
<!-- --><!-- -->
</div>
<div _ngcontent-ng-c1591630683="" aria-hidden="true" aria-labelledby="ageconfirmationModal" class="modal fade" id="ageconfirmationModal" tabindex="-1">
<div _ngcontent-ng-c1591630683="" class="modal-dialog modal-dialog-centered">
<div _ngcontent-ng-c1591630683="" class="modal-content">
<div _ngcontent-ng-c1591630683="" class="login-popup-content">
<div _ngcontent-ng-c1591630683="" class="modal-body ageconfirmationModalclass">
<div _ngcontent-ng-c1591630683="" class="login-panel-container confirm-container">
<div _ngcontent-ng-c1591630683="" class="confirm-text">
<div _ngcontent-ng-c1591630683="" class="header-popup">
<a _ngcontent-ng-c1591630683="" aria-label="Close" class="ui-link" data-bs-dismiss="modal"><i _ngcontent-ng-c1591630683="" class="fas fa-times"></i></a>
</div>
<div _ngcontent-ng-c1591630683="" class="text1 text-confirm-bold">
                            Non-Gambling Territories.
                          </div>
<hr _ngcontent-ng-c1591630683="" class="confirm-line"/>
<div _ngcontent-ng-c1591630683="" class="text2">
                            Connecting to our site from non gambling countries,
                            it will be User's responsibility to ensure that
                            their use of the service is lawful.
                          </div>
</div>
<div _ngcontent-ng-c1591630683="" class="confirm-text">
<div _ngcontent-ng-c1591630683="" class="text1 text-confirm-bold">
                            Underage gambling is prohibited.
                          </div>
<hr _ngcontent-ng-c1591630683="" class="confirm-line"/>
<div _ngcontent-ng-c1591630683="" class="text2">
                            Please confirm if you are
                            <span _ngcontent-ng-c1591630683="">18 years old and above</span>
                            as of today.
                          </div>
</div>
<div _ngcontent-ng-c1591630683="" class="confirm-button">
<button _ngcontent-ng-c1591630683="" class="btn-verification btn-confirm" data-bs-dismiss="modal" routerlink="/login" tabindex="0">
<span _ngcontent-ng-c1591630683="">Confirm</span></button><button _ngcontent-ng-c1591630683="" class="btn-verification" data-bs-dismiss="modal">
<a _ngcontent-ng-c1591630683="" style="text-decoration: none"><span _ngcontent-ng-c1591630683="">Exit</span></a>
</button>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div _ngcontent-ng-c1591630683="" aria-hidden="true" aria-labelledby="exposureModalLabel" class="modal fade exposureModals" id="exposureModals" tabindex="-1">
<div _ngcontent-ng-c1591630683="" class="modal-dialog modal-md">
<div _ngcontent-ng-c1591630683="" class="modal-content">
<div _ngcontent-ng-c1591630683="" class="modal-header exposure-details">
<h1 _ngcontent-ng-c1591630683="" class="modal-title" id="exposureModalLabel">
                      Exposure Detail
                    </h1>
<button _ngcontent-ng-c1591630683="" aria-label="Close" class="close" data-bs-dismiss="modal" type="button">
<span _ngcontent-ng-c1591630683="" aria-hidden="true">×</span>
</button>
</div>
<div _ngcontent-ng-c1591630683="" class="modal-body">
<table _ngcontent-ng-c1591630683="" class="table table-responsive table-bordered">
<thead _ngcontent-ng-c1591630683="">
<tr _ngcontent-ng-c1591630683="" class="theme1font">
<th _ngcontent-ng-c1591630683="" class="text-center">
                            Sport Name
                          </th>
<th _ngcontent-ng-c1591630683="" class="text-center" style="width: 50%">
                            Event Name
                          </th>
<th _ngcontent-ng-c1591630683="" class="text-center">
                            Market Name
                          </th>
<th _ngcontent-ng-c1591630683="" class="text-center">
                            Trade
                          </th>
</tr>
</thead>
<!-- -->
<tfoot _ngcontent-ng-c1591630683="">
<tr _ngcontent-ng-c1591630683="" class="exposurebody">
<td _ngcontent-ng-c1591630683="" class="text-center" colspan="4">
                            No real-time records found
                          </td>
</tr>
</tfoot>
<!-- -->
</table>
</div>
</div>
</div>
</div>